// @ts-nocheck
import axios from 'axios';
import { useCallback } from 'react';

import API_ENDPOINTS from '../../const/ApiEndPoints';

export default function useLandScape() {
  const getLandScapeData = useCallback((params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_LANDSCAPE_DATA}`,
        { params, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getLandScapeViewEntities = useCallback((params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_LANDSCAPE_DATA2}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const saveLandscapeViewEntities = useCallback((body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_LANDSCAPE_DATA2}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const createLandscapeView = useCallback((body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_LANDSCAPE_DATA2}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getLandScapeSingleEntity = useCallback((params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.LANDSCAPE_SINGLE_ENTITY}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getLandscapeSavedViews = useCallback(() => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_LANDSCAPE_VIEWS}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const deleteLandscapeSavedViews = useCallback((params) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_LANDSCAPE_VIEWS}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  return {
    getLandScapeData,
    getLandScapeViewEntities,
    saveLandscapeViewEntities,
    createLandscapeView,
    getLandScapeSingleEntity,
    getLandscapeSavedViews,
    deleteLandscapeSavedViews,
  };
}
